// Desconto que está na tela de pagamento e ainda não foi gravado — o que o
// cupom impresso de dentro da tela leva como `descontoRodada` (dono,
// 21/10/2026: "todo desconto aplicado tem que sair no cupom").
//
// A tela calcula o desconto sobre o que está sendo pago agora (produtos
// marcados); a conta impressa é da mesa inteira, então aqui a base é o que
// falta pagar da mesa. Na divisão, o que falta é o desconto das partes ainda
// não pagas — o das pagas já está no `desconto_acumulado`.
const centavos = (v) => Math.round((Number(v) || 0) * 100);
const reais = (c) => Math.round(c) / 100;

function descontoDaDivisao(divisao, log) {
  if (!divisao.desconto) return { valor: 0 };
  const pago = (Array.isArray(log) ? log : [])
    .filter((l) => l?.efeito && l.efeito.divisaoId === divisao.id)
    .reduce((s, l) => s + centavos(l.efeito.desconto), 0);
  const falta = Math.max(0, centavos(divisao.bruto) - centavos(divisao.liquido) - pago);
  return { ...divisao.desconto, valor: reais(falta) };
}

function centavosDoTipo(tipo, valor, cupom, baseC) {
  if (tipo === "percent") return Math.round(baseC * Math.min(100, Math.max(0, Number(valor) || 0)) / 100);
  if (tipo === "fixed") return Math.min(baseC, centavos(valor));
  if (tipo === "coupon") return Math.min(baseC, centavos(cupom?.discount));
  return 0;
}

/**
 * `{ tipo, valor, cupom, base, divisao, log }` → `{ valor, tipo, percentual, cupom }`.
 * `tipo`/`valor`: estado do campo de desconto ('none' | 'percent' | 'fixed' |
 * 'coupon'); `cupom`: o cupom aplicado ({ code, discount }); `base`: o que falta
 * pagar da mesa; `log`: pagamentos da sessão (o `efeito.desconto` de cada parte).
 */
export function descontoEmAndamento({ tipo, valor, cupom, base, divisao, log } = {}) {
  if (divisao) return descontoDaDivisao(divisao, log);
  const c = centavosDoTipo(tipo, valor, cupom, Math.max(0, centavos(base)));
  return {
    valor: reais(Math.max(0, c)),
    tipo: tipo === "none" ? null : tipo,
    percentual: tipo === "percent" ? Number(valor) || 0 : null,
    cupom: tipo === "coupon" ? cupom?.code || null : null,
  };
}
